module.exports = "<p>\n  droch-icon-svg-reg works!\n</p>\n"